import { StepAnalyseEnum } from './analyse-credit';
import { BaseModel } from './base-model';
import { User } from './user';

export class AnalyzeStepHistory extends BaseModel {

	public id: string;
	public step: StepAnalyseEnum;
	public action: ActionStepEnum;
	public date: number;
	public user: User;
	public justification: string;
	public powerStep: PowerStep;

	constructor() {
		super();
		this.id = null;
		this.step = null;
		this.action = null;
		this.date = null;
		this.user = null;
		this.justification = null;
		this.powerStep = null;
	}

}

export enum ActionStepEnum {
	DEFERRED,
	DEFERRED_RESERVATION,
	DEFERRED_HIGHER,
	REJECTED,
	CANCELED,
	ANALYZE,
	REANALYZE
}

export class PowerStep {

	public step: StepAnalyseEnum;
	public value: number;
	public acceptance: number;

	constructor() {
		this.step = null;
		this.value = null;
		this.acceptance = null;
	}

}
